import React, { useState } from 'react';
import {
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useFlow } from '../../contexts/FlowContext';
import { WebFlowLayout } from '../WebFlowLayout';
import { FlowPrimaryButton } from '../components/FlowPrimaryButton';
import { FlowTextField } from '../components/FlowTextField';
import { StudioFlowColors } from '../studioFlowTheme';
import { SessionAPI } from '../../utils/sessionApi';

export const InstructionsScreen: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { state, updateState } = useFlow();
  const [isSaving, setIsSaving] = useState(false);

  const handleContinue = async () => {
    setIsSaving(true);
    await SessionAPI.updateWebSession({
      sessionId: state.sessionId,
      specialInstructions: state.specialInstructions.trim(),
    });
    setIsSaving(false);
    navigate('/done');
  };

  const continueButton = (
    <FlowPrimaryButton onClick={handleContinue} disabled={isSaving}>
      Continue
    </FlowPrimaryButton>
  );

  return (
    <WebFlowLayout
      title="Any special instructions you'd like to add?"
      subtitle="*Optional"
    >
      <Box sx={{ pb: { xs: 14, md: 0 } }}>
        <FlowTextField
          placeholder="Special instructions"
          multiline
          minRows={5}
          value={state.specialInstructions}
          onChange={(event) =>
            updateState({ specialInstructions: event.target.value })
          }
          inputProps={{ 'aria-label': 'Special instructions' }}
        />

        {isDesktop && <Box sx={{ mt: 3 }}>{continueButton}</Box>}
      </Box>
      {!isDesktop && (
        <Box
          sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            bgcolor: StudioFlowColors.background,
            px: 3,
            pt: 2,
            pb: 'calc(16px + env(safe-area-inset-bottom))',
          }}
        >
          {continueButton}
        </Box>
      )}
    </WebFlowLayout>
  );
};
